<template>
    <div>
        <b-overlay :show="is_load" >
            <div class="source_price_block">
                <div class="form-group mt-2">
                    <label class="form-label" for="wlocal">
                        {{__t("POSTER_RELATION_REST_CONNECT")}}*
                    </label>

                    <div class="" v-if="rest_list.length > 0">
                        <v-select v-model="active_poster"
                                  class="imc_reasons"
                                  label="name"
                                  :reduce="item => item.spot_id + ':' + item.poster_acc"
                                  :options="this.rest_list"
                                  :filterable="false"
                        >
                            <template slot="no-options">
                                {{__t("CHOICE_REST")}}
                            </template>

                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    <div>
                                        {{ option.name }}
                                    </div>
                                    <div>
                                        <small>
                                            SPOT_ID: {{option.spot_id}} - POSTER_ACC:{{option.poster_acc}}
                                        </small>
                                    </div>
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>

            <div class="button_block">
                <div class="sync_it w-100 mt-4 d-flex">
                    <button  type="button"
                             v-if="can_save"
                            v-on:click="save_relation"
                            class="btn btn-success waves-effect waves-themed flex-fill mr-4">
                        {{__t('ATTACH')}}
                    </button>

                    <button  type="button" v-if="can_detach"
                            v-on:click="remove_relation"
                            class="btn btn-outline-danger waves-effect waves-themed flex-fill">
                        {{__t('REMOVE')}}
                    </button>
                </div>
            </div>


        </b-overlay>
    </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
    name: "poster_connect",
    props : {
        "rest" : {
            type : Object,
        }
    },
    components : {
        vSelect
    },
    data() {
        return {
            is_load : false,
            attached_poster : {
                'id' : 0,
                'poster_id' : 0,
                'poster_acc' :"",
                'spot_id' : 0,
                'rest_id': parseInt(this.rest.id),
            },
            rest_list : [],
        }
    },
    created() {
        this.get_params();
    },
    methods : {
        get_params() {
            this.load_attached_poster();
            this.load_connect_rest_list();
        },


        async save_relation() {
            this.is_load = true;
            await pos_api.put('/restaurants/poster/' + parseInt(this.rest.id) + "/connect",this.attached_poster).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    //this.attached_poster = {...this.attached_poster,...data.data};
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    delay_time: 9000,
                    position: "b-toaster-top-left",
                    title: this.__t("ERR_DEL_POS")
                })
            });
        },

        async remove_relation() {
            if(parseInt(this.attached_poster.id) > 0) {
                this.is_load = true;
                await pos_api
                    .delete('/restaurants/poster/connect/' + parseInt(this.attached_poster.id))
                    .then(({data}) => {
                        this.is_load = false;
                        this.attached_poster =  {
                                'id' : 0,
                                'poster_id' : 0,
                                'poster_acc' :"",
                                'spot_id' : 0,
                                'rest_id': parseInt(this.rest.id),
                        };

                    }).catch(({response}) => {
                        this.is_load = false;
                        EventBus.$emit('show_toast', {
                            err: response.data.message,
                            type: "danger",
                            delay_time: 9000,
                            position: "b-toaster-top-left",
                            title: this.__t("ERR_DEL_POS")
                        })
                    });
            }
        },


        async load_attached_poster() {
            if(parseInt(this.rest.id) > 0) {
                this.is_load = true;
                await pos_api.get('/restaurants/poster/' + parseInt(this.rest.id) + "/connect").then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {

                        this.attached_poster = {...this.attached_poster,...data.data};
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        delay_time: 9000,
                        position: "b-toaster-top-left",
                        title: this.__t("ERR_DEL_POS")
                    })
                });
            }
        },

        async load_connect_rest_list() {
            if(parseInt(this.rest.id) > 0) {
                this.is_load = true;
                await pos_api.get('/restaurants/poster/' + parseInt(this.rest.id) + "/spots_list").then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.rest_list = data.data;
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        delay_time: 9000,
                        position: "b-toaster-top-left",
                        title: this.__t("ERR_DEL_POS")
                    })
                });
            }
        }
    },
    computed : {
        has_attached () {
            return parseInt(this.attached_poster.id) > 0;
        },

        can_detach() {
            return this.has_attached;
        },

        can_save() {
            return parseInt(this.attached_poster.spot_id) > 0;
        },

        attached_poster_val() {

            if(parseInt(this.attached_poster.spot_id) > 0) {
                return this.attached_poster.spot_id + ':' + this.attached_poster.poster_acc;
            }
            return null;
        },

        active_poster: {
            get :function () {
                return this.attached_poster_val;
            },
            set: function(val) {
                if(val) {
                    let split = val.split(':')
                    if(split.length > 0) {
                        this.attached_poster.poster_acc = split[1];
                        this.attached_poster.spot_id = parseInt(split[0]);
                    }
                }

                else {
                    this.attached_poster.poster_acc = '';
                    this.attached_poster.spot_id = 0;
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
